import { createContext, useContext } from "react";
import { type FormTheme } from "./decoration";

/**
 * The active form-document theme, provided by every themed mount point
 * (FormRenderer's document root and the composer's document frame) and read
 * by portal-rendered surfaces (FormPopover, FormDrawer). CSS custom
 * properties resolve lexically, so anything portaled to document.body leaves
 * the `[data-form-theme]` DOM scope and must RE-APPLY it on the portal
 * container for the theme vars to resolve; React context crosses
 * createPortal, so the portal can learn the theme even though the DOM scope
 * is lost. The app's `.dark` class lives on <html>, which still ancestors
 * every portal — only the theme attribute needs re-application.
 */
export const FormThemeContext = createContext<FormTheme>("precision");

export function useFormTheme(): FormTheme {
  return useContext(FormThemeContext);
}
